import { Index } from './index';
import { Show } from './show';
import { New } from './new';
import { Edit } from './edit';

export default {

    index() {
        document.addEventListener('DOMContentLoaded', () => {
            new Index().Run();
        }, false);
    },
    show() {
        document.addEventListener('DOMContentLoaded', () => {
            new Show().Run();
        }, false);
    },
    new() {
        document.addEventListener('DOMContentLoaded', () => {
            new New().Run();
        }, false);
    },
    edit() {
        document.addEventListener('DOMContentLoaded', () => {
            new Edit().Run();
        }, false);
    }

}
